<script>
import {
  ArrowUpIcon,
  MonitorIcon,
  FeatherIcon,
  EyeIcon,
  UserCheckIcon,
  SmartphoneIcon,
  ZoomInIcon,
  FileIcon,
  ApertureIcon,
  UploadIcon,
  VideoIcon,
  DownloadIcon,
  Share2Icon,
  HeartIcon,
} from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import Pricing from "@/components/pricing2";
import Testimonial from "@/components/testimonial";
/**
 * Index application component
 */
export default {
  data() {
    return {
      testimonialData: [
        {
          id: 1,
          profile: "images/client/01.jpg",
          message:
            "It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.",
          name: "Thomas Israel",
          designation: "C.E.O",
        },
        {
          id: 2,
          profile: "images/client/02.jpg",
          message:
            "One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others.",
          name: "Barbara McIntosh",
          designation: "M.D",
        },
        {
          id: 3,
          profile: "images/client/03.jpg",
          message:
            "The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century.",
          name: "Carl Oliver",
          designation: "P.A",
        },
        {
          id: 4,
          profile: "images/client/04.jpg",
          message:
            "According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero.",
          name: "Christa Smith",
          designation: "Manager",
        },
        {
          id: 5,
          profile: "images/client/05.jpg",
          message:
            "There is now an abundance of readable dummy texts. These are usually used when a text is required.",
          name: "Dean Tolle",
          designation: "Developer",
        },
        {
          id: 6,
          profile: "images/client/05.jpg",
          message:
            "Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts.",
          name: "Jill Webb",
          designation: "Designer",
        },
      ],
       pricingData: [
        {
          title: "Free",
          price: 0,
          feature: [
            "Full Access",
            "Enhanced Security",
            "Source Files",
            "1 Domain Free",
          ],
          button: "Buy Now",
        },
        {
          title: "Starter",
          price: 39,
          feature: [
            "Full Access",
            "Source Files",
            "Free Appointments",
            "Enhanced Security",
          ],
          button: "Get Started",
          isBest: true,
        },
        {
          title: "Professional",
          price: 59,
          feature: [
            "Full Access",
            "Enhanced Security",
            "Source Files",
            "1 Domain Free",
          ],
          button: "Try it Now",
        },
      ],
    };
  },
  components: {
    Navbar,
    Footer,
    Pricing,
    Testimonial,
    ArrowUpIcon,

    Carousel,
    Slide,
    MonitorIcon,
    FeatherIcon,
    EyeIcon,
    UserCheckIcon,
    SmartphoneIcon,
    ZoomInIcon,
    FileIcon,
    ApertureIcon,
    UploadIcon,
    VideoIcon,
    DownloadIcon,
    Share2Icon,
    HeartIcon,
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half-170 d-table w-100" id="home">
      <div class="container">
        <div class="row mt-5 align-items-center">
          <div class="col-lg-6 col-md-7">
            <div class="title-heading">
              <h1 class="heading mb-3"> {{$t('mobile.title')}} </h1>
              <p class="para-desc" v-html="$t('mobile.description')"></p>
              <div class="mt-4">
                <a href="javascript:void(0)" v-b-modal.download-modal class="btn btn-primary mt-2 mr-2"><i class="mdi mdi-apple"></i> iOS App</a>
                <a href="https://www.pgyer.com/designmirror" target="_blank" rel="noopener"
                   onclick="_czc.push(['_trackEvent', 'app', 'download', 'android']);"
                   class="btn btn-outline-primary mt-2"><i class="uil uil-android"></i> Android App</a>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-6 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <div class="text-md-right text-center ml-lg-4">
              <img loading="eager" fetchpriority="high" src="/images/photoshop/mobile-app.png" :alt="$t('alt.mobile_app')" width="800" />
            </div>
          </div>
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->


    <b-modal id="download-modal" ref="login-modal" hide-footer
             :title="$t('mobile.modal.title')"
             header-close-variant="white"
             no-close-on-backdrop
             header-class="border-0"
             content-class="border-0" centered >
      <div class="text-center">
        <p v-html="$t('mobile.modal.detail')"></p>
        <a href="https://apps.apple.com/cn/app/id1106217536" target="_blank" rel="noopener"
           onclick="_czc.push(['_trackEvent', 'app', 'download', 'ios']);"
           class="btn btn-primary mt-2"><i class="mdi mdi-apple"></i> {{ $t('mobile.modal.appstore') }}</a>
      </div>
    </b-modal>

    <!-- Shape Start -->
    <div class="position-relative">
      <div class="shape overflow-hidden text-light">
        <svg
          viewBox="0 0 2880 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!--Shape End-->

    <!-- Features Start -->
    <section class="section bg-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h2 class="h4 title mb-4">{{$t('mobile.feature.title')}}</h2>
              <p class="text-muted para-desc mb-0 mx-auto" v-html="$t('mobile.feature.description')"> </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->


        <div class="row justify-content-center align-items-center">
          <div class="col-lg-8 col-md-8">
            <div class="row mt-4 pt-2">
              <div class="col-md-6 col-12" v-for="(item, index) in $t('index.app.features')">
                <div class="media features pt-4 pb-4">
                  <div class="icon text-center rounded-circle text-primary mr-3 mt-2">
                    <zoom-in-icon v-if="index === 0" class="fea icon-ex-md text-primary"></zoom-in-icon>
                    <file-icon v-if="index === 1" class="fea icon-ex-md text-primary"></file-icon>
                    <aperture-icon v-if="index === 2" class="fea icon-ex-md text-primary"></aperture-icon>
                    <upload-icon v-if="index === 3" class="fea icon-ex-md text-primary"></upload-icon>
                    <download-icon v-if="index === 4" class="fea icon-ex-md text-primary"></download-icon>
                    <share2-icon v-if="index === 5" class="fea icon-ex-md text-primary"></share2-icon>
                  </div>
                  <div class="media-body">
                    <h2 class="h4 title">{{item.title}}</h2>
                    <p class="text-muted para mb-0">
                      {{item.description}}
                    </p>
                  </div>
                </div>
              </div>
              <!--end col-->
            </div>
            <!--end row-->
          </div>
          <!--end col-->

          <div class="col-lg-4 col-md-4 col-12 mt-4 pt-2 text-center text-md-right" >
            <img width="800" height="1488" loading="lazy" src="/images/index/index-feature-4.png" class="img-fluid" :alt="$t('alt.feature_upload')" />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Feature End -->

    <!-- Section End -->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
